var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFluidLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 277,
    height: 97,
    viewBox: "0 0 277 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brand",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    fillRule: "nonzero",
    transform: "translate(-212 -302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(212 302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fill: "#0E0F3B",
    d: "M276.49 14.68v65.49H268v-7h-.19c-3.8 5.31-10.17 8.23-17.34 8.23-14.24 0-25.48-10.8-25.48-25.22 0-14.95 10.62-26.37 25.22-26.37 6.63 0 12.89 2.35 16.89 7.35h.18V14.68h9.21Zm-104.9 16.46v26.63c0 10.23 3.72 15.22 12.21 15.22s12.83-5.93 12.83-15.4V31.16h9.2v49h-8.41v-5.31h-.17c-2.43 4.16-7.97 6.55-14.43 6.55-10.52 0-20.43-5.67-20.43-22.92V31.14h9.2Zm-27.34-16.46v8.41c-5.48 0-8.58 1.68-8.58 5.84v2.21h8.58v8.41h-8.58v40.61h-9.2V28.93c0-8.32 5.66-14.25 15.66-14.25h2.12Zm13 0v65.47h-9.2V14.68h9.2Zm62.91 16.38v49.02h-9.2V31.06h9.2Zm30.75 7.17c-9.38 0-16.72 7.87-16.72 17.52 0 9.25 7.52 17.25 16.72 17.25l.326-.004c9.098-.185 16.465-7.474 16.747-16.57l.007-.326c0-10-6.73-17.87-17.08-17.87Zm-30.75-23.62V25.4h-9.2V14.61h9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#3DD0AE",
    d: "M22.11 0C10.08.256.46 10.082.46 22.115c0 12.033 9.62 21.86 21.65 22.115h22.12V22.11C44.192 9.911 34.309.033 22.11 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#FFC541",
    d: "M22.11 51.78H0v22.11a22.12 22.12 0 1 0 22.11-22.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#D33282",
    d: "M70.81 0C58.78.256 49.16 10.082 49.16 22.115c0 12.033 9.62 21.86 21.65 22.115h22.11V22.11C92.882 9.915 83.005.038 70.81 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#2264EA",
    d: "M70.81 51.78H48.7v22.11C48.7 86.101 58.599 96 70.81 96s22.11-9.899 22.11-22.11-9.899-22.11-22.11-22.11Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluidLogo);
export default __webpack_public_path__ + "static/media/fluid-logo.63db7df2fe62a51f11e2948dffdd82d8.svg";
export { ForwardRef as ReactComponent };